define('mode-generator',['require','exports','module','lodash'],function (require, exports, module) {
    var _ = require('lodash');

    /*
     * Create allowed modes, default modes and audioType
     *
     * @param user's settings
     * @return object of allowed, default and audioType
     */
    var modeGenerator = function (usersSettings) {
        var allowed = {};
        var defaults = [];
        var audioType;

        if (usersSettings) {
            var audioSettings = usersSettings.audio;

            _.forEach(audioSettings.allowedModes, function (data) {
                allowed[data] = true;
            });

            _.forEach(audioSettings.defaultModes, function (data) {
                // set audio type
                audioType = data !== 'PRIVATE' ? 'PROVIDED' : 'PRIVATE';
                if (allowed.hasOwnProperty(data)) {
                    // defaults can have modes that are now allowed? Filtered out here.
                    defaults.push(data);
                }
            });

            return {
                allowed: allowed,
                defaults: defaults,
                audioType: audioType
            };
        }
        return undefined;
    };

    module.exports = modeGenerator;
});

